import React from "react";
import "./Suggestions.css";
import Text from "../Text/Text";
import classNames from "classnames";
import Flex from "../Flex/Flex";

export type Suggestion = {
  id: number;
  label: string;
  icon?: React.ReactNode;
  onClick?: () => void;
};

type SuggestionsProps = {
  className?: string;
  suggestions: Array<Suggestion>;
  onClick?: (suggestion: Suggestion) => void;
  suggestionRenderer?: (suggestion: Suggestion) => React.ReactNode;
};

const Suggestions = React.memo(
  ({
    suggestions,
    onClick,
    className,
    suggestionRenderer,
  }: SuggestionsProps) => {
    if (suggestions.length === 0) {
      return null;
    }

    return (
      <div className={classNames(className, "Suggestions")}>
        {suggestions.map(x => (
          <Flex
            className="Suggestions__Suggestion"
            key={x.id}
            align="center"
            onClick={() => {
              if (x.onClick) {
                x.onClick();
              }
              if (onClick) {
                onClick(x);
              }
            }}
          >
            {suggestionRenderer ? (
              suggestionRenderer(x)
            ) : (
              <>
                {x.icon && (
                  <i className="Suggestions__Suggestion__Icon">{x.icon}</i>
                )}
                <Text size={3}>{x.label}</Text>
              </>
            )}
          </Flex>
        ))}
      </div>
    );
  }
);

export default Suggestions;
